import { c as _c } from "react/compiler-runtime";
import { Star } from 'lucide-react';
import { GRADE_SCALE } from '@/lib/grades';
import { type GetActivityItem } from './ActivityItem';
export const GradeStars = t0 => {
  const $ = _c(7);
  const {
    activity,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  let t2;
  if ($[0] !== activity.grades) {
    t2 = activity.grades?.find(_temp);
    $[0] = activity.grades;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const defaultGrade = t2;
  const score = defaultGrade?.score ?? 0;
  if (score === 0) {
    return null;
  }
  const starSize = size === "sm" ? "w-3 h-3" : "w-4 h-4";
  let t3;
  if ($[2] !== score || $[3] !== starSize) {
    t3 = GRADE_SCALE.map(s => <Star key={s} className={`${starSize} ${s <= score ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`} />);
    $[2] = score;
    $[3] = starSize;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex items-center gap-0.5">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(g) {
  return g.type === "default";
}